'use strict';

var _classCallCheck = require("C:\\j\\workspace\\Snap_Blockly_develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\j\\workspace\\Snap_Blockly_develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\j\\workspace\\Snap_Blockly_develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\j\\workspace\\Snap_Blockly_develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\j\\workspace\\Snap_Blockly_develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var fs = require('fs');

var stream = require('stream');

var parse = require('./parser');

var stringify = require('./stringifier');

module.exports = parse;
module.exports.stringify = stringify;
/* ------- Transform stream ------- */

var Parser =
/*#__PURE__*/
function (_stream$Transform) {
  _inherits(Parser, _stream$Transform);

  function Parser(opts) {
    var _this;

    _classCallCheck(this, Parser);

    opts = opts || {};
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Parser).call(this, {
      objectMode: true
    }));
    _this._extract = parse.mkextract(opts);
    return _this;
  }

  _createClass(Parser, [{
    key: "_transform",
    value: function _transform(data, encoding, done) {
      var block;
      var lines = data.toString().split(/\n/);

      while (lines.length) {
        block = this._extract(lines.shift());

        if (block) {
          this.push(block);
        }
      }

      done();
    }
  }]);

  return Parser;
}(stream.Transform);

module.exports.stream = function stream(opts) {
  return new Parser(opts);
};
/* ------- File parser ------- */


module.exports.file = function file(file_path, done) {
  var opts = {};
  var collected = [];

  if (arguments.length === 3) {
    opts = done;
    done = arguments[2];
  }

  return fs.createReadStream(file_path, {
    encoding: 'utf8'
  }).on('error', done).pipe(new Parser(opts)).on('error', done).on('data', function (data) {
    collected.push(data);
  }).on('finish', function () {
    done(null, collected);
  });
};